export function formatDuration(duration: string | number, includePrefix = false) {
    const newDuration = (typeof duration === 'string' ? parseInt(duration) : duration) || 0

    return `${!includePrefix ? '' : newDuration < 0 ? '-' : '+'}${Math.abs(newDuration) / 3600 < 10 ? '0' : ''}${Math.floor(Math.abs(newDuration) / 3600)}:${(Math.abs(newDuration) % 3600) / 60 < 10 ? '0' : ''}${Math.floor((Math.abs(newDuration) % 3600) / 60)}`
}

export function formatDistance(distance: number | string, includePrefix = false) {
    const parsedDistance = (typeof distance === 'string' ? parseInt(distance) : distance) || 0

    const scaledDistance = parsedDistance < 10000 ?
        `${(parsedDistance / 1000).toFixed(1)} km` :
        `${(parsedDistance / 1000).toFixed(0)} km`

    return `${!includePrefix ? '' : parsedDistance < 0 ? '' : '+'}${scaledDistance}`
}

export function formatGrams(grams: number | string) {
    grams = (typeof grams === 'string' ? parseFloat(grams) : grams) || 0

    let fixed = (grams / 1000).toFixed(3)
    let trimmed = fixed.replace(/\.?0+$/, '')
    return trimmed.replace('.', ',')
}

export function validateUrl(url: string) {
    const urlObject = new URL(`https://${url.replace('https://', '').replace('http://', '')}`)
    return urlObject.toString()
}

export function sleep(ms: number) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms)
    })
}
